// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__jSdWu","text":"SelectPayment_text__ysLCY","title":"SelectPayment_title__39TTD","btn":"SelectPayment_btn__Dm6A1"};